import { render, staticRenderFns } from "./benefitsAdd.vue?vue&type=template&id=2d804e4f&scoped=true"
import script from "./benefitsAdd?vue&type=script&lang=js&external"
export * from "./benefitsAdd?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d804e4f",
  null
  
)

export default component.exports